import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
      
      <div className="prose prose-indigo prose-lg text-gray-500 mx-auto">
        <p className="lead">
          This Privacy Policy describes how RankTheBlank.js collects, uses, and shares your personal information
          when you use our website and services.
        </p>
        
        <h2>Information We Collect</h2>
        <p>
          When you use RankTheBlank.js, we may collect the following types of information:
        </p>
        <ul>
          <li><strong>Account Information:</strong> When you create an account, we collect your email address, username, and password.</li>
          <li><strong>Poll Data:</strong> Information about polls you create, your votes, and your participation in other polls.</li>
          <li><strong>Usage Information:</strong> How you interact with our website, including pages visited and features used.</li>
          <li><strong>Device Information:</strong> Information about the device and browser you use to access our service.</li>
        </ul>
        
        <h2>How We Use Your Information</h2>
        <p>
          We use the information we collect to:
        </p>
        <ul>
          <li>Provide, maintain, and improve RankTheBlank.js</li>
          <li>Process and manage your account</li>
          <li>Fulfill the purposes for which you provided the information</li>
          <li>Send you technical notices, updates, and support messages</li>
          <li>Respond to your comments and questions</li>
          <li>Protect against fraud and abuse</li>
        </ul>
        
        <h2>Information Sharing</h2>
        <p>
          We do not sell your personal information. We may share your information in the following circumstances:
        </p>
        <ul>
          <li>With your consent</li>
          <li>To comply with legal obligations</li>
          <li>To protect our rights, privacy, safety, or property</li>
          <li>In connection with a merger, sale, or acquisition</li>
        </ul>
        
        <h2>Your Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your personal information, including:
        </p>
        <ul>
          <li>Access to your personal information</li>
          <li>Correction of inaccurate information</li>
          <li>Deletion of your information</li>
          <li>Restriction of processing</li>
          <li>Data portability</li>
        </ul>
        
        <h2>Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information.
          However, no method of transmission over the Internet or electronic storage is 100% secure.
        </p>
        
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the
          new Privacy Policy on this page and updating the "Last Updated" date.
        </p>
        
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:
          <br />
          <a href="mailto:privacy@ranktheblank.js">privacy@ranktheblank.js</a>
        </p>
        
        <div className="mt-8">
          <Link to="/" className="text-indigo-600 hover:text-indigo-900">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Privacy;